import * as api from "@/api/williams/renewals";
import { queryKeys } from "../../queryKeys";
import { Renewal, RenewalAdvisoryRequest } from "@/api/williams/renewals";
import { useQuery } from "react-query";

export function useWelderAdvisories(renewal: Renewal) {
  const filters: RenewalAdvisoryRequest = {
    process: renewal.process,
    technique: renewal.technique,
    welders: renewal.welders,
  };

  return useQuery({
    queryKey: queryKeys.renewal.advisories(filters),
    queryFn: () => api.getAdvisories(filters),
  });
}
